export default "__VITE_ASSET__48def5d3__"